import { render, staticRenderFns } from "./SelectComponentDialog.vue?vue&type=template&id=535d15d0&scoped=true"
import script from "./SelectComponentDialog.vue?vue&type=script&lang=js"
export * from "./SelectComponentDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectComponentDialog.vue?vue&type=style&index=0&id=535d15d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535d15d0",
  null
  
)

export default component.exports